import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import titleLogo from '../assets/loginTitleLogo.svg'; // adjust path as needed
import AlembicLogo from '../assets/Made With Love from Alembic.svg'; // adjust path as needed
// import background from '../assets/background.png'; // used in CSS
import { useAuth } from '../AuthContext';
import Popup from '../services/Popup';

export default function Login() {
  const navigate = useNavigate();
  const [emailOrSap, setEmailOrSap] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const [popupMessage, setPopupMessage] = useState('');

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn')) {
      navigate('/home');
    }
  }, [navigate]);

  const handleLogin = async () => {
    if (emailOrSap && password) {
      let data = {
        "sapcode": emailOrSap,
        "password": password
      }
      try {
        const response = await fetch('https://alembicdigilabs.in/medicaldictionary/v1/eyecare/login', {
          method: 'POST', // HTTP method
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          const result = await response.json();
          if (result.token) {
            login(result.token, result.user?.id);
            sessionStorage.setItem('user', JSON.stringify(result.user));
            navigate('/home');
          } else {
            setPopupMessage(result.message || "Unknown error");
          }
        } else {
          setPopupMessage('Login failed. Please check your credentials.');
        }
      } catch (error) {
        console.error('Error:', error);
        setPopupMessage('Something went wrong. Please try again.');
      }
    }
  };

  const isFormValid = emailOrSap.trim() !== '' && password.trim() !== '';
  // 
  return (
    <div className="login-container">
      <div className="login-box">
        <img src={titleLogo} alt="Title Logo" className="login-logo" />
        <div className="form-group mt-4">
          <label className='mb-2'>Enter Your SAP Code</label>
          <input
            type="text"
            className="form-control"
            placeholder="Example: 2947183"
            value={emailOrSap}
            onChange={(e) => setEmailOrSap(e.target.value)}
          />
        </div>
        <div className="form-group mt-3">
          <label className='mb-2'>Enter Your Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button
          className="btn login-btn mt-4"
          disabled={!isFormValid}
          onClick={handleLogin}
        >
          Log In
        </button>
        <img src={AlembicLogo} alt="Title Logo" className="loveAlembic" />
      </div>
       {popupMessage && <Popup message={popupMessage} onClose={() => setPopupMessage('')} />}
    </div>
  );
}
